import React, { useCallback, useState } from 'react';
import { Switch, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CDN_TYPE_SPORT, getCDNUrl } from 'utils';

import { CategoryProvider, SiteConfigManager, usePreferences, useSportState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Flag } from '@atlas/ui';

import MenuItemFavoriteExpand from 'common/MenuItem/MenuItemFavoriteExpand';
import categoryShape from 'common/PropTypes/categoryShape';

import CategoryLoader from './CategoryLoader';
import CategoryTournamentsList from './CategoryTournamentsList';

const { SPORT_LIVE } = COMPONENT_TYPES;

const ExpandableCategoryTournaments = ({
  category,
  clickedCategory,
  expandedCategory,
  forceIsExpanded = false,
  primaryTournamentUrlName,
}) => {
  const [isExpanded, setIsExpanded] = useState(forceIsExpanded);

  const { id: categoryId, imagePaths, name, regionId, sportId } = category;
  const imagePath = imagePaths?.FLAG;

  const livePath = SiteConfigManager.getComponentPath(SPORT_LIVE);

  const { pathname } = useLocation();

  const { getIsCategoryFavorite, selectFavoriteCategory } = usePreferences();
  const isCategoryFavorite = !!getIsCategoryFavorite({ categoryId, sportId });

  const toggleExpanded = useCallback(() => {
    setIsExpanded(isExpanded => !isExpanded);
  }, [setIsExpanded]);

  const { mainMarketTypes } = useSportState();

  const setFavoriteCategoryHandler = useCallback(() => {
    selectFavoriteCategory({ categoryId, sportId });
  }, [categoryId, selectFavoriteCategory, sportId]);

  const CategoryTournaments = (
    <CategoryProvider category={category}>
      <CategoryLoader>
        <Switch>
          <CategoryTournamentsList
            categoryId={categoryId}
            clickedCategory={clickedCategory}
            expandedCategory={expandedCategory}
            forceIsExpanded={forceIsExpanded}
            mainMarketTypes={mainMarketTypes}
            primaryTournamentUrlName={primaryTournamentUrlName}
            sportId={sportId}
          />
        </Switch>
      </CategoryLoader>
    </CategoryProvider>
  );

  if (`/${pathname.split('/')[1]}` === livePath) {
    return CategoryTournaments;
  }

  return (
    <div className="category-table-container">
      <MenuItemFavoriteExpand
        dataTestId="category"
        dataTestItemId={category.id}
        icon={
          <Flag
            alt={name}
            cdnHostname={getCDNUrl(CDN_TYPE_SPORT)}
            className="lang-flag"
            imagePath={imagePath}
            name={regionId}
          />
        }
        isExpanded={isExpanded}
        isFavorite={isCategoryFavorite}
        mainLabel={name}
        setFavorite={setFavoriteCategoryHandler}
        toggleExpanded={toggleExpanded}
      />
      {isExpanded && CategoryTournaments}
    </div>
  );
};

ExpandableCategoryTournaments.propTypes = {
  category: categoryShape.isRequired,
  clickedCategory: PropTypes.number,
  forceIsExpanded: PropTypes.bool,
};

export default ExpandableCategoryTournaments;
